/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { useNavigate, useParams } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import MainLayout from '../Layouts/Mainlayout';
import { Divider, Grid, IconButton } from '@mui/material';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { getBulkEmailCampaignById, updateBulkEmailCampaign } from '../../services/bulkEmailServices';
import EditBulkEmailForm from './EditBulkEmailForm';
import type { NewBulkEmailCampaignInputs } from './AddNewBulkEmailForm';
import BulkEmailSummary from './BulkEmailSummary';
import { ARE_YOU_SURE, UNKNOWN_ERR, BULK_UNSUBSCRIBE_LEVELS } from 'src/constants/constant';
import BulkEmailImportCSV from './BulkEmailImportCSV';
import BulkEmailReview from './BulkEmailReview';
//@ts-ignore
import { CircleArrowLeft01Icon } from '@hugeicons-pro/core-duotone-rounded';
import { HugeiconsIcon } from '@hugeicons/react';
import { checkEventPermission } from 'src/common/utility/utility';
import type { RootState } from '../types/types';
import { useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
//@ts-ignore
import { MultiplicationSignStrokeStandard } from '@hugeicons-pro/core-stroke-standard';

const steps = ['Import', 'Schedule', 'Review', 'Confirmation'];

export interface AddNewBulkEmailFormRef {
  getFormData: () => NewBulkEmailCampaignInputs | null;
  validateForm: () => boolean;
  setFormData: (data: any) => void; // Add this method to pre-populate form
}

function EditBulkEmailCampaign(): JSX.Element {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [initialLoading, setInitialLoading] = useState<boolean>(true);
  const [sourceCSVFileName, setSourceCSVFileName] = useState<string>('');
  const [uploadedCSVFileName, setUploadedCSVFileName] = useState<string>('');
  const [bulkEmailData, setBulkEmailData] = useState<NewBulkEmailCampaignInputs | null>(null);
  const formRef = useRef<AddNewBulkEmailFormRef>(null);
  const [activeStep, setActiveStep] = React.useState(0); // Start from Import step for edit
  const [isFileUploaded, setIsFileUploaded] = useState<boolean>(false); // Will be set to true after loading data
  const [bulkCampaignDataIdentifier, setBulkCampaignDataIdentifier] =  useState<string>('');
  const [selectedSeedList, setSelectedSeedList] = useState<any>(null);
  const [selectedSuppressionList, setSelectedSuppressionList] = useState<any>(null);
  const [selectedSeedListName, setSelectedSeedListName] = useState<string>('');
  const [selectedSuppressionListName, setSelectedSuppressionListName] = useState<string>('');
  const [originalCampaignData, setOriginalCampaignData] = useState<any>(null);
  const [emailsSuppressedCount, setEmailsSuppressedCount] = useState<number>(0);
  const [emailsUploadedCount, setEmailsUploadedCount] = useState<number>(0);
  const [seedDataCount, setSeedDataCount] = useState<number>(0);
  // ✅ Add state to store the same data for summary page
  const [summaryData, setSummaryData] = useState<any>(null);
    const [bulkCampaignTotalCount, setBulkCampaignTotalCount] = React.useState(0);
  const param = useParams();
  const { id } = param;
   //@ts-ignore
  const { role } = useSelector((state: RootState) => state.auth);
const [showUpdateBulkCampaignModal, setShowUpdateBulkCampaignModal] = useState<boolean>(false);
const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false);



  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
  useEffect(() => {
    if (id) {
      setInitialLoading(true);
      getBulkEmailCampaignById(id)
        .then((res: any) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              const campaignData = res.data.data;
              console.log('Loaded campaign data:', campaignData);
              setOriginalCampaignData(campaignData);
              // Set file related data
              setSourceCSVFileName(campaignData.sourceCSVFileName || '');
              setUploadedCSVFileName(campaignData.uploadedCSVFileName || '');
              setBulkCampaignDataIdentifier(campaignData.bulkCampaignDataIdentifier ?? '');
              setIsFileUploaded(true); // Mark file as uploaded
              if (campaignData.seedListNames) {
                setSelectedSeedListName(campaignData.seedListNames);
              }
              if (campaignData.supressionListNames) {
                setSelectedSuppressionListName(campaignData.supressionListNames);
              }
              // Prepare form data
              const formData = {
                name: campaignData.bulkCampaignName,
                startDateTime: campaignData.bulkCampaignStartDate,
                templateId: campaignData.templateId?.toString(),
                unsubscribeTypeId: campaignData.unsubscribeTypeId?.toString(),
                priority: campaignData.priority?.toString(),
                templateName: campaignData.templateName,
                templateIdentifier: campaignData.templateIdentifier,
                templateVersion: campaignData.templateVersion,
                templateContent: campaignData.templateContent,
                campaignStartDate: campaignData.bulkCampaignStartDate,
                campaignEndDate: campaignData.campaignEndDate,
                resendSchedules: campaignData.resendDateTimeLst?.map((item: any, index: number) => ({
                  resendOrder: item.resendOrder,
                  resendDateTime: item.resendDateTime,
                  resendType: item.resendType?.toString()
                })) || []
              };
              
              // Set bulk email data for review
              setBulkEmailData(formData);
              if (campaignData.seedListId) {
                const seedIds = campaignData.seedListId.split(",").map((id: string) => id.trim());
                console.log('Parsed seed IDs:', seedIds);
                setSelectedSeedList(seedIds);
              }
              if (campaignData.supressionListId) {
                const suppressionIds = campaignData.supressionListId.split(",").map((id: string) => id.trim());
                console.log('Parsed suppression IDs:', suppressionIds);
                setSelectedSuppressionList(suppressionIds);
              }
              
            } else {
              NotificationManager.error('Campaign not found');
              navigate('/bulk-email');
            }
          }
        })
        .catch((error: any) => {
          console.log("Error: ", error);
          NotificationManager.error('Error loading campaign data');
        })
        .finally(() => {
          setInitialLoading(false);
        });
    }
  }, [id, navigate]);

  // Function to handle file upload success from child component (not used in edit)
  const handleFileUploadSuccess = (uploadData: any): void => {
  console.log('File upload successful:', uploadData);
  setIsFileUploaded(true);
  
  // ✅ Update all the file-related states with new values
  setSourceCSVFileName(uploadData.sourceCSVFileName);
  setUploadedCSVFileName(uploadData.uploadedCSVFileName);
  setBulkCampaignDataIdentifier(uploadData.bulkCampaignDataIdentifier);
  
  // ✅ Also update the original campaign data to reflect the new file
  setOriginalCampaignData((prev: any) => ({
    ...prev,
    sourceCSVFileName: uploadData.sourceCSVFileName,
    uploadedCSVFileName: uploadData.uploadedCSVFileName,
    bulkCampaignDataIdentifier: uploadData.bulkCampaignDataIdentifier
  }));
};

  // Function to handle file removal from child component (not used in edit)
  const handleFileRemoval = (): void => {
    setIsFileUploaded(false);
    setSourceCSVFileName('');
    setUploadedCSVFileName('');
    setBulkCampaignDataIdentifier('');
    setEmailsUploadedCount(0);
  };

  const handleNext = async (): Promise<void> => {
    console.log('Active Step:', activeStep);
    // Step 0: Import (Skip for edit)
    if (activeStep === 0) {
        if (!isFileUploaded) {
            NotificationManager.error('Please upload a CSV file before proceeding');
            return;
          } 
          else if (bulkCampaignTotalCount === 0) {
            NotificationManager.error('There are no valid records in the uploaded CSV');
            return;
             }
      setActiveStep(1);
      return;
    }

    // Step 1: Schedule - validate form
    if (activeStep === 1) {
      if (formRef.current) {
        // eslint-disable-next-line @typescript-eslint/await-thenable
        const isValid =  await formRef.current.validateForm();
        if (isValid) {
          // eslint-disable-next-line @typescript-eslint/await-thenable
          const formData =  await formRef.current.getFormData();    
      //@ts-ignore
          setBulkEmailData({
            ...formData,
            seedListName: selectedSeedListName,
            suppressionListName: selectedSuppressionListName,
          });
          setActiveStep(2);
        } else {
          console.log('❌ Form validation failed');
          NotificationManager.error('Please fill in all required fields');
        }
      }
      return;
    }
      // Step 2: Review - Final submission
      if (activeStep === 2) {
        if (bulkEmailData) {
          const isAdminUser =
            !!checkEventPermission('BULKEMAIL_EDIT_ACTIVE') ;

          if (isAdminUser &&  originalCampaignData?.isActive === true) {
            // Show confirmation modal for admin users
            setShowUpdateBulkCampaignModal(true);
          } else {
            // Direct update for other users
            await handleFormSubmit(bulkEmailData);
          }
        }
        return;
      }
   
  };

  const handleBack = (): void => {
    if (activeStep === 0) {
      // Go back to campaigns list from import step
      navigate('/bulk-email');
    } else {
      setActiveStep((prevStep) => prevStep - 1);
    }
  };

  const handleCancel = (): void => {
    navigate('/bulk-email');
  };

  const handleSeedListChange = (seedList: any): void => {
    const seedListIds = seedList && seedList.length > 0
    ? seedList.map((s: any) => s.id).join(",")
    : "";
    const seedListNames = seedList && seedList.length > 0 
    ? seedList.map((s: any) => s.name).join(",") 
    : "";
    setSelectedSeedList(seedListIds);
    setSelectedSeedListName(seedListNames);
  };

  const handleSuppressionListChange = (suppressionList: any): void => {
    const suppressionListIds = suppressionList && suppressionList.length > 0
    ? suppressionList.map((s: any) => s.id).join(",")
    : "";
    const suppressionListNames = suppressionList && suppressionList.length > 0
    ? suppressionList.map((s: any) => s.name).join(",")
    : "";
    setSelectedSuppressionList(suppressionListIds);
    setSelectedSuppressionListName(suppressionListNames);
  };
const handleTotalRecipientsCalculated = (total: number, seedDataCount: number, emailsSuppressedCount: number, emailsUploaded:number): void => {
  console.log('Total recipients calculated:', total);
  setBulkCampaignTotalCount(total);
  setSeedDataCount(seedDataCount);
  setEmailsSuppressedCount(emailsSuppressedCount);
  setEmailsUploadedCount(emailsUploaded);
};
const handleUpdateBulkCampaignConfirm = async (): Promise<void> => {
  if (bulkEmailData) {
    setIsModalSaveLoading(true);
    try {
      await handleFormSubmit(bulkEmailData);
      setShowUpdateBulkCampaignModal(false);
    } catch (error) {
      console.error('Error in confirmation update:', error);
    } finally {
      setIsModalSaveLoading(false);
    }
  }
};

const handleUpdateBulkCampaignClose = (): void => {
  setShowUpdateBulkCampaignModal(false);
}
const handleFormSubmit = async (data: NewBulkEmailCampaignInputs): Promise<void> => {
  console.log('Final form submission with data:', data);
  setLoading(true);
  try {
    const userData = JSON.parse(localStorage.getItem('user') ?? '{}');

    const normalizeToCsv = (value: any): string => {
      if (!value) return "0"; // Return "0" instead of null

      if (Array.isArray(value)) {
        return value.length > 0 ? value.join(",") : "0"; // Return "0" for empty arrays
      }

      if (typeof value === "string") {
        return value.trim() !== "" ? value : "0"; // Return "0" for empty strings
      }

      return "0"; // Return "0" for any other case
  };

  const seedListId = normalizeToCsv(selectedSeedList);
  const supressionListId = normalizeToCsv(selectedSuppressionList);



    
    // Prepare the payload for the API
    const emailBulkData = {
      bulkCampaignId: originalCampaignData?.bulkCampaignId,
      clientId: userData?.clientId ?? 0,
      templateId: data?.templateId,
      unsubscribeTypeId: 2,
      priority: data?.priority,
      BulkCampaignIdentifierId: originalCampaignData?.bulkCampaignIdentifier ?? '',
      
      // ✅ Use current state values instead of originalCampaignData
      bulkCampaignDataIdentifier: bulkCampaignDataIdentifier, // This will be the latest value
      
      bulkCampaignName: data.name,
      bulkCampaignStartDate: data.startDateTime,
      // ✅ Use current state values instead of originalCampaignData  
      sourceCSVFileName: sourceCSVFileName,
      uploadedCSVFileName: uploadedCSVFileName,
      
      updatedBy: userData?.id || 0,
      resendDateTime: data.resendSchedules,
      parentId: originalCampaignData?.parentId || 0,
      // unsubscribeTypeId:1
    };

    const normalizeValue = (val: unknown): string | null => {
        if (val == null) return null; // handles null & undefined
        if (typeof val === "object") return null; // exclude objects
        const str = String(val).trim();
        return str && str !== "0" ? str : null;
      };

      const normalizedSeed = normalizeValue(seedListId);
      const normalizedSuppression = normalizeValue(supressionListId);

      if (normalizedSeed) {
        //@ts-ignore
        emailBulkData.seedListId = normalizedSeed;
      }

      if (normalizedSuppression) {
        //@ts-ignore
        emailBulkData.supressionListId = normalizedSuppression;
      }

    console.log('Final submission payload:', emailBulkData);

    // Use update API instead of create
    const res = await updateBulkEmailCampaign(emailBulkData);

    if (res.status === 200) {
      if (res.data.result === 1) {
        console.log(res.data);
        setSummaryData({
            ...res.data.data,
            seedListName: selectedSeedListName, 
            suppressionListName: selectedSuppressionListName 
        });
        
        NotificationManager.success('Bulk email updated successfully');
        setActiveStep(3);
      } else {
        const errorMsg: any = res.data.messages[0].message;
        NotificationManager.error(
          errorMsg.includes('A bulk campaign with the same name already exists') 
            ? 'Bulk email name already exists'
            : UNKNOWN_ERR,
          '',
          5000,
        );
      }
    }
  } catch (error: any) {
    console.error('Error occurred:', error);
    NotificationManager.error('Unknown error has occurred');
  } finally {
    setLoading(false);
  }
};

  if (initialLoading) {
    return (
      <div className="flex flex-row justify-start">
        <MainLayout>
          <div className="flex justify-center items-center h-64">
            <span className="loading loading-spinner text-primary"></span>
          </div>
        </MainLayout>
      </div>
    );
  }



const hasPermission = !!checkEventPermission('BULKEMAIL_UPDATE'); // coerce to boolean
const roleKey = role?.[0]?.roleKey;
const isAdmin = !!checkEventPermission('BULKEMAIL_EDIT_ACTIVE');
const isActive = originalCampaignData?.isActive === true;

const isProcessing = originalCampaignData?.isProcessing === true;
const isDisabled =
  activeStep === 2 &&
  (
    isProcessing ||
    !hasPermission ||        // no permission -> always disabled
    (!isAdmin && isActive)   // non-admin + isActive true -> disabled
  );
  
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <div className="flex justify-between items-center">
          <div className="w-full">
            <div>
              <h1 className="text-2xl text-title font-semibold">
                Edit Bulk Email
              </h1>

              <Box sx={{ flexGrow: 1 }}>
               {loading &&
                  <div className="flex justify-center items-center relative">
                    <span className="loading loading-spinner text-primary"></span>
                  </div>
}
                  <div className="campaign-form-container">
                    <Grid>
                      <Box sx={{ width: '60%', marginTop: '10px', mx: 'auto' }}>
                        <Stepper activeStep={activeStep} alternativeLabel>
                          {steps.map((label, index) => (
                            <Step key={label} completed={index === 0 ? true : undefined}>
                              <StepLabel>{label}</StepLabel>
                            </Step>
                          ))}
                        </Stepper>
                      </Box>
                      
                      <div style={{ marginTop: '40px' }}>
                        {/* Import step - show existing file details and tables */}
                        <div style={{ display: activeStep === 0 ? 'block' : 'none' }}>
                          <BulkEmailImportCSV 
                          onFileUploadSuccess={handleFileUploadSuccess}
                          onFileRemoval={handleFileRemoval}
                          onSeedListChange={handleSeedListChange}
                          onSuppressionListChange={handleSuppressionListChange}
                          isEditMode={true}
                          existingFileData={{originalCampaignData}}
                           onTotalRecipientsCalculated={handleTotalRecipientsCalculated}
                        />
                         
                        </div>

                        <div style={{ display: activeStep === 1 ? 'block' : 'none' }}>
                          <EditBulkEmailForm
                          //@ts-ignore
                            ref={formRef}
                            defaultValues={{
                              name: originalCampaignData.bulkCampaignName,
                              templateId: String(originalCampaignData.templateId),
                              unsubscribeTypeId: originalCampaignData.unsubscribeTypeId?.toString(),
                              priority: originalCampaignData.priority?.toString(),
                              //@ts-ignore
                              startDateTime: originalCampaignData.bulkCampaignStartDate,
                              resendSchedules: originalCampaignData.resendDateTimeLst?.map((r: any) => ({
                                resendOrder: r.resendOrder,
                                resendDateTime: r.resendDateTime,
                                resendType: String(r.resendType),
                              })),
                              createdOn: originalCampaignData.createdOn,
                              createdUser: originalCampaignData.createdUser,
                              updatedOn: originalCampaignData.updatedOn,
                              updatedUser: originalCampaignData.updatedUser,
                            }}
                            bulkCampaignTotalCount={bulkCampaignTotalCount}
                          />
                          
                        </div>

                        <div style={{ display: activeStep === 2 ? 'block' : 'none' }}>
                          {bulkEmailData && <BulkEmailReview bulkEmailData={bulkEmailData} bulkEmailCreatedOn={originalCampaignData.createdOn}
                              bulkEmailCreatedUser={originalCampaignData.createdUser} seedListName={selectedSeedListName} suppressionListName={selectedSuppressionListName} totalRecipientCount={bulkCampaignTotalCount} seedDataCount={seedDataCount} suppressedCount={emailsSuppressedCount}/>}
                        </div>
                        
                        <div style={{ display: activeStep === 3 ? 'block' : 'none' }}>
                          {/* ✅ Pass the same form data used in review page */}
                          {summaryData && <BulkEmailSummary bulkEmailData={summaryData} campaignData={bulkEmailData} totalRecipientCount={bulkCampaignTotalCount} seedDataCount={seedDataCount} suppressedCount={emailsSuppressedCount} />}
                        </div>
                      </div>

                    
{activeStep !== 3 && (
  <>
  <Divider sx={{ color: '#D9D9D9', marginBottom: '30px', marginTop: '30px' }} />
  <div className="flex justify-between items-center mt-6">
    {/* Left: Cancel */}
    <OutlineButton
      color="gray"
      onClick={handleCancel}
    >
      Cancel
    </OutlineButton>

    {/* Right: Back + Next */}
    <div className="flex gap-2">
      {activeStep !== 0 && (
        <button
            type="button"
            onClick={handleBack}
            style={{
              background: 'none',
              border: 'none',
              color: '#666',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              padding: '8px 16px',
              fontSize: '14px',
            }}
        >
          <span style={{ color: '#666' }}>←</span> Back
        </button>
                      )}

   <GradientButton
  color="red"
  onClick={() => void handleNext()}
  width="150px"
  disabled={isDisabled || ( activeStep === 0 && emailsUploadedCount === 0)
  }
>

        {activeStep === 0
          ? 'Next: Schedule >'
          : activeStep === 1
          ? 'Next: Review'
          : activeStep === 2
          ? 'Update'
          : 'Next'}
      </GradientButton>
    </div>
  </div>
  </>
)}
                    </Grid>
                  </div>
                
              </Box>
            </div>
          </div>
              <BootstrapDialog onClose={handleUpdateBulkCampaignClose} aria-labelledby="customized-dialog-title" open={showUpdateBulkCampaignModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
                              <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                                  Active Bulk Email Confirmation
                              </DialogTitle>
                              <IconButton aria-label="close" onClick={handleUpdateBulkCampaignClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
                                  <HugeiconsIcon
                                      icon={MultiplicationSignStrokeStandard}
                                      size={24}
                                      color="currentcolor"
                                      strokeWidth={0.5}
                                  />
                              </IconButton>
                              <DialogContent>
                                  <p className='text-14 text-muted'>{'This campaign is currently active. Proceeding may impact the existing workflow. Do you want to continue?'}</p>
                              </DialogContent>
                              <DialogActions sx={{ background: '#F9F9F9' }}>
                                  <OutlineButton color='gray' onClick={handleUpdateBulkCampaignClose} width='100px'>No</OutlineButton>
                                  <GradientButton type='button' color='red' onClick={() => { void handleUpdateBulkCampaignConfirm(); }} width='100px'>{!isModalSaveLoading ? 'Yes' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                              </DialogActions>
                          </BootstrapDialog>
        </div>
      </MainLayout>
    </div>
  );
}

export default EditBulkEmailCampaign;